<template>
  <div>
    <div class="mb-6">
      <UploadFile
        :text="'Прикрепите файл'"
        :size="'sm'"
        :type="'file'"
        :value="value"
        @input="$emit('input', $event)"
      />
    </div>
    <vs-button
      :disabled="!value"
      @click.prevent="send"
    >
      Отправить
    </vs-button>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue'

export default {
  components: {
    UploadFile
  },

  props: {
    value: {
      type: String,
      required: true
    }
  },

  methods: {
    send () {
      if (this.value) this.$emit('send')
    }
  }
}
</script>
